// Single source of truth for turning an OcOrderDetail (returned by POST /oc/orders
// and GET /oc/orders/{id}) into the args for generateOcPdf. Used both right after
// creating an order and when downloading from the history table, guaranteeing the
// regenerated PDF is identical to the emitted one.

import { GenerateOcPdfArgs, OcOrderDetail } from "../../types/oc";
import { apiToInternalMode } from "./ocCalc";

export function buildPdfArgsFromDetail(
  detail: OcOrderDetail
): GenerateOcPdfArgs {
  const issuer = detail.issuerSnapshot;
  const client = detail.clientSnapshot;

  return {
    mode: apiToInternalMode(detail.mode),
    company: {
      code: issuer.code,
      legalName: issuer.legalName,
      taxId: issuer.taxId,
      address: issuer.address,
      city: issuer.city,
      zip: issuer.zip,
      country: issuer.country,
      phone: issuer.phone,
      email: issuer.email,
      website: issuer.website,
      logoUrl: issuer.logoUrl,
    },
    client: {
      label: client.label,
      legalName: client.legalName,
      taxId: client.taxId,
      address: client.address,
      city: client.city,
      zip: client.zip,
      country: client.country,
      phone: client.phone,
      email: client.email,
      website: client.website,
      paymentTerms: client.paymentTerms,
      isRBA: client.isRBA,
    },
    items: detail.items,
    totals: detail.totals,
    ocDate: detail.ocDate,
    ocNumber: detail.ocNumber,
    campaign: detail.campaign,
    showCompanyContact: detail.showCompanyContact,
    showClientContact: detail.showClientContact,
    compactMode: detail.compactMode,
  };
}
